import api from 'api/axiosInstance';
import type { RedirectionParams } from 'types/global.types';
import type { CardType, CreateCardResponse } from 'types/transactions.types';

export type CreateCardParams = RedirectionParams & {
  bankCode?: string;
  bankId?: string | number;
  accountReference?: string;
  type: CardType;
  deliveryAddress?: {
    street?: string;
    city?: string;
    postalCode?: string;
    country?: string;
  };
  cardId?: string;
  design: 'aldo' | 'standard';
};

export const createCard = (
  params: CreateCardParams,
): Promise<CreateCardResponse> =>
  api.post(`/v2/accountable-banking/cards/start-flow`, params);
